<template>
	<div class="styled-form styled-form--white-box styled-form--empty">
		<div class="styled-form__overlay">
			<div class="preloader"></div>
		</div>
	</div>
</template>

<script>
	// Created this component in case if we need to style empty preloader on all pages
	export default {};
</script>